<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(to="/administracion/id/usuarios")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i {{getActionOfPage()}} usuario
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.py-3.px-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" :disabled='isView' maxlength='100' placeholder='ingresa tu nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 Rut
                  input.col.form-control(type="text", v-rut="rut", @blur="rutExists", v-model="rut", :disabled='isView', maxlength='12', placeholder='12345678-5', title='ej. 12345678-5')
                  .col-auto.form-group.align-items-center.mb-0.pr-0(v-if="showControl && consultorControl")
                    label.font-weight-bold.pl-0.m-0 Líder
                    input.d-inline-block.ml-2(type="checkbox" v-model="isLeader" :disabled='isView' title='Selecciona si será líder')
                .col-6.form-group.align-items-center.mb-4(v-if="isLeader")
                  label.font-weight-bold.col-3.pl-0.m-0 Etapa
                  input.d-inline-block.ml-2(type="radio" v-model="implementation" value="1" :disabled='isView')
                  label
                    small Implementación 
                  input.d-inline-block.ml-2(type="radio" v-model="implementation" value="0" :disabled='isView')
                  label
                    small Mantención
                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 E-mail
                  input.col.form-control(type="text" v-model="email" :disabled='isView' maxlength='100' placeholder='email@mail.com' title='ej. email@mail.com')

                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 Perfil
                  .col.px-0.ad_select
                    select(v-model='selectedProfile', @change='changeProfile($event)' :disabled='isView')
                      option(:value="null" disabled) Selecciona perfil
                      option(:value="profile.value" v-for="profile in profiles") {{profile.label}}
                  .col-auto.form-group.align-items-center.mb-0.pr-0(v-if="showControl")
                    label.font-weight-bold.pl-0.m-0 Administrador
                    input.d-inline-block.ml-2(type="checkbox" v-model="isAdmin" :disabled='isView' title='Selecciona si será administrador de usuarios')
                
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.font-weight-bold.col-3.pl-0.m-0 Clave
                  input.col.form-control(type="password" v-model="password" :disabled='isView' maxlength='100' placeholder='ingresa clave' title='ingresa clave')
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.font-weight-bold.col-3.pl-0.m-0 Repetir clave
                  input.col.form-control(type="password" v-model="repeatPassword" :disabled='isView' maxlength='100' placeholder='repite clave' title='repita clave')
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.font-weight-bold.col-3.pl-0.m-0 Nombre de usuario
                  input.col.form-control(type="text" v-model="username" :disabled='isView' maxlength='100' placeholder='ingresa nombre de usuario' title='ingresa nombre de usuario')
                
                .col-6.form-group.align-items-center.mb-4(v-if="showControl && consultorControl")
                  label.font-weight-bold.col-3.pl-0.m-0 Roles
                  multiselect(
                    v-model="selectedMultiRole",
                    :options="todosMultiRole",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Roles",
                    label="label",
                    track-by="value",
                    :preselect-first="false"
                    :disabled='isView')
                
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.font-weight-bold.col-3.pl-0.m-0 Colaboradores
                  multiselect(
                    v-model="selectedMultiCollabs",
                    :options="todosMultiCollabs",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Colaboradores",
                    label="label",
                    track-by="value",
                    :preselect-first="false"
                    :disabled='isView')

                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Jefe
                  multiselect.col.px-0(
                    v-model="selectedMultiBoss",
                    :options="leaders",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Jefe",
                    label="label",
                    track-by="value",
                    :preselect-first="false")

                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.col-3.pl-0.m-0 Kpi externos
                  multiselect.col.px-0(
                    v-model="selectedMultiKpiExternos",
                    :options="kpiexternos",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Kpi",
                    label="label",
                    track-by="value",
                    :preselect-first="false")

                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 Contratista
                  .col.px-0.ad_select
                    select(v-model='selectedContractor', :disabled='isView')
                      option(:value="null" disabled) Selecciona contratista
                      option(:value="c.value" v-for="c in contractors") {{c.label}}

          .d-flex.flex-row.mt-5
            router-link.stepper-button.previous(to="/administracion/id/usuarios")
              i.material-icons
              span Volver
            button.col-auto.stepper-button.next.ml-auto(v-if="!isView", @click="setUser()")
              span Guardar
              i.material-icons


</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionUsuariosDetail',
  components: {
     Multiselect
  },
  data () {
    return {
      name: null,
      username: null,
      password: null,
      repeatPassword: null,
      rut: null,
      isLeader: false,
      email: null,
      isAdmin: false,
      selectedProfile: null,
      selectedContractor: null,
      profiles: null,
      selectedMultiCollabs: [],
      todosMultiCollabs: [],
      selectedMultiRole: [],
      todosMultiRole: [],
      selectedMultiKpiExternos: [],
      isView: false,
      showControl: false,
      consultorControl: false,
      implementation: null,
      leaders: [],
      selectedMultiBoss: [],
      kpiexternos: [],
      contractors: []
    }
  },
  methods: {
    ...mapActions('profile', [
      'profileList'
    ]),
    ...mapActions('travel', [
      'travelList'
    ]),
    ...mapActions('segment', [
      'ByTravelIds'
    ]),
    ...mapActions('product', [
      'BySegmentIds'
    ]),
    ...mapActions('user', [
      'updateUser',
      'getUserById',
      'getUsers',
      'getRoles',
      'getLeaders',
      'existsUserByRut'
    ]),
    ...mapActions('kpiexterno', [
      'kpiSelectList'
    ]),
    ...mapActions('contractor', [
      'contractorSelectList'
    ]),
    getValuesOfMultiSelect(valuesMultiSelect) {
      return valuesMultiSelect.map(values => values.value)
    },
    getItemsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: p.name}))
    },
    getSelectedAfterChangedParent(todos, oldSelectedItems) {
      return todos.filter(t => oldSelectedItems.map(o => o.value).includes(t.value))
    },
    getValueImplementation(implementation) {
      return implementation == true ? '1': '0'
    },
    setUserProps(user) {
      const vm = this
      vm.id = user._id,
      vm.name = user.name
      vm.username = user.username
      // vm.password = user.password
      // vm.repeatPassword = user.password
      vm.rut = user.rut
      vm.isLeader = user.leader === undefined ? false : user.leader
      vm.email = user.email
      vm.isAdmin = user.isAdmin === undefined ? false : user.isAdmin
      vm.selectedProfile = user.profile._id
      vm.changeProfile(vm.selectedProfile)
      vm.selectedMultiCollabs = vm.getItemsToMultiSelectLoad(user.collabs)
      vm.selectedMultiRole = vm.getItemsToMultiSelectLoad(user.role)
      vm.implementation = vm.getValueImplementation(user.implementation)
      vm.selectedMultiBoss = vm.getItemsToMultiSelectLoad(user.boss)
      vm.selectedMultiKpiExternos = vm.getItemsToMultiSelectLoad(user.kpiext)
      vm.selectedContractor = user.contractor ? user.contractor._id : null
    },
    getUserFromProps() {
      const vm = this
      return {
        id: vm.id,
        name: vm.name.replace(/\t/g, '').trim(),
        username: vm.username,
        password: vm.password,
        rut: vm.rut,
        leader: vm.isLeader,
        email: vm.email,
        isAdmin: vm.isAdmin,
        profile: vm.selectedProfile,
        collabs: vm.getValuesOfMultiSelect(vm.selectedMultiCollabs),
        role: vm.getValuesOfMultiSelect(vm.selectedMultiRole),
        implementation: vm.implementation,
        boss: vm.getValuesOfMultiSelect(vm.selectedMultiBoss),
        kpiext: vm.getValuesOfMultiSelect(vm.selectedMultiKpiExternos),
        contractor: vm.selectedContractor
      }
    },
    loadDetail(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle...')
      const user = vm.$store.getters['auth/getUserInfo']
      vm.getUserById(id).then(user => {
        vm.setUserProps(user);
        vm.loadProfiles();
        vm.loadCollabs();
        vm.loadRole();
        vm.loadLeaders();
        vm.loadKpiExternos();
        vm.loadContractors();
        loading.hide()
      }).catch(error => {
        vm.notify(error)
        loading.hide()
      })
    },
    onlyCollabsActives(items) {
      return items.filter(u => u.isDeleted === false).sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
    },
    loadCollabs() {
      const vm = this
      vm.getUsers({}).then(response => {
        if (vm.isConsultor()) {
          vm.todosMultiCollabs = vm.$store.getters['user/getUsers'].filter(collab => {
            let val = (collab.profile != ("Técnico" || "Colaborador") && collab.leader == true) ? true : false
            return val
          })
          vm.todosMultiCollabs = vm.getItemsToMultiSelectLoad(vm.todosMultiCollabs)
        } else {
          vm.todosMultiCollabs = vm.getItemsToMultiSelectLoad(vm.onlyCollabsActives(response))
        }        
      })      
    },
    loadRole() {
      const vm = this
      vm.getRoles({}).then(response => {
        vm.todosMultiRole = vm.getItemsToMultiSelectLoad(response)
      })
    },
    loadProfiles() {
      const vm = this
      vm.profileList().then(response => {
        vm.profiles = vm.getItemsToMultiSelectLoad(response)
      })
    },
    loadLeaders() {
      const vm = this
      vm.getLeaders().then(response => {
        vm.leaders = vm.getItemsToMultiSelectLoad(response)
      })
    },
    loadKpiExternos() {
      const vm = this;
      vm.kpiSelectList().then(response => {
        vm.kpiexternos =  vm.getItemsToMultiSelectLoad(response);
      });
    },
    loadContractors() {
      const vm = this;
      vm.contractorSelectList().then(response => {
        vm.contractors = vm.getItemsToMultiSelectLoad(response);
      })
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    setUser() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const userdata = vm.getUserFromProps()
        vm.updateUser(userdata).then(result => {
          if (!result.success) {
            loading.hide()
            vm.notify(true, result.message)
          } else {
            loading.hide()
            vm.notify(false, 'Usuario actualizado')
          }
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
      } else {
        loading.hide()
      }
    },
    isThecnicalOrCollab() {
      const vm = this
      return ['5cd08f620dbf793238fd3274','5cd8f7002e7122d70e3e8c73', '66904f00bad6c1a2c28a5fa6'].includes(vm.selectedProfile)
    },
    isConsultor() {
      const vm = this
      return '5d5fc8c37a039508e3303629' == vm.selectedProfile
    },
    changeProfile($event) {
      const vm = this
      const canVisibleAllControls = !vm.isThecnicalOrCollab()
      vm.showControl = canVisibleAllControls
      vm.consultorControl = !vm.isConsultor()
      if (vm.isConsultor()) {
        vm.todosMultiCollabs = vm.$store.getters['user/getUsers'].filter(collab => {
          let val = (collab.profile != ("Técnico" || "Colaborador" || "Consultor externo") && collab.leader == true) ? true : false
          return val
        })
        vm.todosMultiCollabs = vm.getItemsToMultiSelectLoad(vm.todosMultiCollabs)
      } else {
        vm.loadCollabs()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null && input.length > 0
    },
    isSamePassword() {
      const vm = this
      return vm.password.trim() === vm.repeatPassword.trim()
    },
    isValidEmail: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    isValidRut(rut) {
      const re = /[0-9]{7,8}-[0-9Kk]{1}/
      return re.test(rut)
    },
    validate() {
      const vm = this
      let valid = true
      let missing = ''
      const isThecnicalOrCollab = vm.isThecnicalOrCollab()
      const isConsultor = vm.isConsultor()
      
      if (!vm.isValidInput(vm.name)) {
        missing = 'nombre'
        valid = false
      } else if (!vm.isValidInput(vm.rut)) {
        missing = 'rut o no es un rut valido'
        valid = false
      } else if (!vm.isValidInput(vm.email)) {
        missing = 'email'
        valid = false
      } else if (!vm.isValidEmail(vm.email)) {
        missing = 'email con uno válido.'
        valid = false
      }

      if (!isThecnicalOrCollab) {
        if (!isConsultor) {
          // if (!vm.isValidInput(vm.password)) {
          //   missing = 'clave'
          //   valid = false
          // } else if (!vm.isValidInput(vm.repeatPassword)) {
          //   missing = 'repetir clave'
          //   valid = false
          // } else 
          // if (!vm.isSamePassword()) {
          //   missing = 'clave. Debe ser igual a repetir clave'
          //   valid = false
          // } else 
          if (!vm.isValidInput(vm.username)) {
            missing = 'nombre de usuario'
            valid = false
          } else if (!vm.isValidInput(vm.selectedMultiRole)) {
            missing = 'roles'
            valid = false
          } else if (!vm.isValidInput(vm.selectedMultiCollabs)) {
            missing = 'colaboradores'
            valid = false
          } else if (vm.isLeader && vm.implementation == null) {
            missing = 'etapa'
            valid = false
          }
        }
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: `Debe completar el campo ${missing}`,
          closeable: true,
          duration: 5000
        })
        return false
      }
    },
    getIsEditPage() {
      return this.$route.path.split('/').reverse()[0] === 'edit'
    },
    getActionOfPage() {
      const vm = this
      return vm.getIsEditPage() ? 'Editar' : 'Ver'
    },
    enabledControls() {
      const vm = this
      vm.isView = !vm.getIsEditPage()
    },
    rutExists() {
      const vm = this
      if (vm.rut != '' && vm.rut != undefined && vm.rut != null) {
        if (vm.isValidRut(vm.rut)) {
          vm.existsUserByRut({rut: vm.rut, id: this.$route.params.id}).then((result) => {
            if (result.message) {
              vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: `El rut ${vm.rut} ya esta activo en el sistema`,
              closeable: true,
              duration: 9000
            })
            }
          }).catch(error => {
            vm.notify(true, error.payload.message)
          })
        }
      }
    }
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id)
    vm.enabledControls()
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-usuarios-detail.vue